import React from 'react';
import URI from 'urijs';
import { appQueryParameters } from '@clubmed/utils';
import domainsService from '@clubmed/domains-service';
import * as routeBuilder from 'Routes/routeBuilder';
import { t } from 'Src/i18n';
import { useAppContext } from 'Context/ReactAppContext';
import { Modal } from 'Components/frameworks/modal/Modal';
import { Button } from 'Components/frameworks/button/Button';
import { Title } from 'Components/frameworks/title/Title';
import { ID_MODAL_HEADER__BE__MISMATCH_COUNTRY } from 'Components/utils/identifiers/constants';
import { isStrictlyProductionEnv, isStrictlyStagingEnv } from 'Utils/context/contextUtils';
import { QUERY_DEPARTURE_DATE, QUERY_DURATION, QUERY_NUMBER_OF_ADULTS } from 'Utils/uri/constants';
type Props = {
  selectedProposal: Proposal;
  resort: Product;
};
export const BlockMismatchProposalCountry = ({ selectedProposal, resort }: Props) => {
  const appContext = useAppContext();

  if (
    !selectedProposal.originalLocale ||
    selectedProposal.originalLocale.split('-')[1] === appContext.country
  ) {
    return null;
  }

  return (
    <Modal
      ariaLabelledby={ID_MODAL_HEADER__BE__MISMATCH_COUNTRY}
      ariaLabel={t('booking.participants.mismatchLocalePLE.title')}
      closeLabel={t('common.close')}
      onClose={() => {
        let redirectUrl = new URI(window.location.href).setQuery({
          locale: selectedProposal.originalLocale,
        });

        if (isStrictlyProductionEnv() || isStrictlyStagingEnv()) {
          redirectUrl = redirectUrl.tld(
            domainsService.getTldFromLocale(selectedProposal.originalLocale),
          );
        }

        if (appContext.isUserLogged || appContext.isUserQuickLogged) {
          redirectUrl = new URI(window.location.href).resource(
            routeBuilder.buildUrl(
              'signout',
              {},
              {
                redirectUri: redirectUrl,
              },
            ),
          );
        }

        // heroku or local env
        window.location.href = redirectUrl.toString();
      }}
    >
      <div className="p-20 text-center">
        <Title
          className="my-15 justify-center"
          hLevel={1}
          id={ID_MODAL_HEADER__BE__MISMATCH_COUNTRY}
          theme="title-brand-n2"
        >
          {t('booking.participants.mismatchLocalePLE.title')}
        </Title>
        <p className="mb-20">{t('booking.participants.mismatchLocalePLE.label')}</p>
        <Button
          url={new URI(resort.href)
            .addQuery({
              locale: appContext.locale,
              [QUERY_NUMBER_OF_ADULTS]: selectedProposal.attendees.adults.length,
              [QUERY_DURATION]: selectedProposal.duration,
              [QUERY_DEPARTURE_DATE]: selectedProposal.arrivalDate,
            })
            .removeQuery(
              appQueryParameters.booking.selectedProposalId,
              appQueryParameters.booking.proposalIds,
            )
            .toString()}
        >
          {t('common.continue')}
        </Button>
      </div>
    </Modal>
  );
};
